export default {
  title: 'Parteneri',
  search_placeholder: 'Căutați partener...',
  buttons: {
    default_price_list: 'Listă de prețuri implicită',
    create_partner: 'Creați partener',
  },
  columns: {
    name: 'Nume',
    restaurants: 'Restaurante',
    shop_domain: 'Domeniu magazin',
    status: 'Status',
    earning_enabled: 'Câștiguri activate',
  },
  statuses: {
    invited: 'Invitat',
    active: 'Activ',
    suspended: 'Suspendat',
  },
  actions: {
    edit: 'Editare',
    view_billing: 'Vezi facturare',
    view_as_partner: 'Vezi ca partener',
    suspend: 'Suspendare',
    unsuspend: 'Reactivare',
  },
  suspension: {
    suspend_title: 'Suspendați acest partener?',
    suspend_description:
      'Toți membrii echipei partenerului vor fi dezactivați și sesiunile lor revocate. Restaurantele rămân active.',
    unsuspend_title: 'Reactivați acest partener?',
    unsuspend_description: 'Toți membrii echipei partenerului vor fi reactivați și se vor putea autentifica din nou.',
  },
  toasts: {
    load_error: 'Nu s-au putut încărca partenerii.',
    suspended: 'Partenerul a fost suspendat.',
    unsuspended: 'Partenerul a fost reactivat.',
    suspension_error: 'Nu s-a putut modifica statusul partenerului.',
    view_as_error: 'Nu s-a putut deschide panoul partenerului.',
  },
};
